export var Direction;
(function (Direction) {
    /**
     * up
     */
    Direction[Direction["Asc"] = 0] = "Asc";
    /**
     * down
     */
    Direction[Direction["Desc"] = 1] = "Desc";
})(Direction || (Direction = {}));
export var SortTypes;
(function (SortTypes) {
    SortTypes[SortTypes["PT"] = 0] = "PT";
    SortTypes[SortTypes["Grade"] = 1] = "Grade";
    SortTypes[SortTypes["Time"] = 2] = "Time";
    SortTypes[SortTypes["Student"] = 3] = "Student";
})(SortTypes || (SortTypes = {}));
